// Single source of truth for portfolio entries.
// Both the homepage preview and the /work page read from here.
//
// Notes:
//  - `featured: true` makes the card span the full width on /work.
//  - `status: "Live"` cards show on the homepage preview (first two).
//  - `stats` is optional; when present, it renders a 4-up time-savings grid
//    inside the card body in place of the plain outcome line.

export const PROJECTS = [
  {
    slug: "porta-potty-ops",
    category: "Business Tool",
    title: "Porta-potty operator — dispatch, tracking, and invoicing tool",
    description:
      "A unit tracker, dispatching system, and automated invoicing platform built for a sanitation services company. Replaces hours of daily admin with one-click routing, automatic unit assignment, and a mobile driver app.",
    shortDescription:
      "Dispatching, unit tracking, and automated invoicing for a sanitation services company.",
    outcome: "Deployable in 1–2 days. Hours of daily admin replaced with one-click routing and automated invoicing.",
    stats: [
      { value: "45 min", label: "Saved daily", caption: "One-click routes" },
      { value: "20 min", label: "Saved per job", caption: "Auto unit assignment" },
      { value: "30 min", label: "Saved daily", caption: "Mobile driver app" },
      { value: "100%",   label: "Automated",   caption: "Invoice generation" },
    ],
    status: "Live",
    featured: true,
    video:
      "https://iframe.mediadelivery.net/embed/234682/adcce6c3-8dd5-4790-b5b0-c111daab7e19",
    poster:
      "https://vz-ebdf7ee9-e45.b-cdn.net/adcce6c3-8dd5-4790-b5b0-c111daab7e19/thumbnail_268e55ff.jpg",
  },
  {
    slug: "law-firm-ops",
    category: "Business Tool",
    title: "Law firm operations tool — currently in build",
    description:
      "A custom operations tool for a small law group — in active development. Workflow automation, matter tracking, and the kind of internal tooling a small firm shouldn't have to glue together themselves.",
    shortDescription:
      "Workflow automation and matter tracking for a small law group — in active build.",
    stats: [
      { value: "60 min", label: "Saved daily",       caption: "Case management" },
      { value: "45 min", label: "Saved per matter",  caption: "Legal research" },
      { value: "75%",    label: "Faster",            caption: "Document drafting" },
      { value: "30%",    label: "More matters",      caption: "Per attorney monthly" },
    ],
    status: "In Progress",
    featured: true,
    video:
      "https://iframe.mediadelivery.net/embed/234682/3191fd85-5e03-4469-976c-0cd7284c104b",
    poster:
      "https://vz-ebdf7ee9-e45.b-cdn.net/3191fd85-5e03-4469-976c-0cd7284c104b/thumbnail.jpg",
  },
  {
    slug: "trustee-governance",
    category: "Business Tool",
    title: "Trustee governance — documentation tool for Trustees",
    description:
      "A web app that helps Trustees govern their trust by handling the documentation side end-to-end. Replaces scattered docs and email threads with a single, structured tool.",
    shortDescription:
      "A web app helping Trustees govern their trust — built around the documentation side.",
    stats: [
      { value: "25 min", label: "Saved per document", caption: "Drafting & review" },
      { value: "$300/hr", label: "Legal fees avoided", caption: "vs. attorney-drafted docs" },
      { value: "45%",    label: "Less time",          caption: "Trust admin overall" },
      { value: "100%",   label: "Audit-ready",        caption: "Full documentation trail" },
    ],
    status: "Live",
    video:
      "https://iframe.mediadelivery.net/embed/234682/e843cde5-94bc-4bb8-97ab-1fe51a29551d",
    poster:
      "https://vz-ebdf7ee9-e45.b-cdn.net/e843cde5-94bc-4bb8-97ab-1fe51a29551d/thumbnail.jpg",
  },
  {
    slug: "customer-training-portal",
    category: "Web App",
    title: "Customer training portal — learning, documents, and progress tracking",
    description:
      "A web product built around training their customers — helping them learn and grow. Documents are processed and delivered automatically, and customers always know exactly where they are in the process.",
    shortDescription:
      "Customer training, document delivery, and clear progress tracking in one web app.",
    outcome: "Customers know exactly where they are in the journey.",
    status: "Live",
    video:
      "https://iframe.mediadelivery.net/embed/234682/9a9b8245-5332-4322-af4c-b32aedda60f8",
    poster:
      "https://vz-ebdf7ee9-e45.b-cdn.net/9a9b8245-5332-4322-af4c-b32aedda60f8/thumbnail_6cd52fb9.jpg",
  },
  {
    slug: "ai-agent-dev-tool",
    category: "Developer Tool",
    title: "Developer platform for the AI agent industry",
    description:
      "A platform built for the AI agent industry — clean API endpoints, in-context documentation, the developer experience this category was missing.",
    shortDescription:
      "API + documentation platform for the AI agent industry.",
    outcome: "Live and shipping to developers.",
    status: "Live",
    video:
      "https://iframe.mediadelivery.net/embed/234682/4cbdc832-d839-443f-b22b-ed87879510f9",
    poster:
      "https://vz-ebdf7ee9-e45.b-cdn.net/4cbdc832-d839-443f-b22b-ed87879510f9/thumbnail_0e80552c.jpg",
  },
  {
    slug: "freelance-ops-tool",
    category: "Business Tool",
    title: "Freelance operations — purpose-built workflow tool",
    description:
      "A tool built for a specific freelance group, designed to strip out the admin and operational friction that drains hours from billable work each week.",
    shortDescription:
      "A workflow tool that removes the admin draining billable hours from a freelance group.",
    stats: [
      { value: "50 min", label: "Saved daily",       caption: "Admin & ops" },
      { value: "30%",    label: "Faster payments",   caption: "Invoice to deposit" },
      { value: "<5 min", label: "Per invoice",       caption: "Quote → send → paid" },
      { value: "5 hrs",  label: "Reclaimed weekly",  caption: "Back to billable work" },
    ],
    status: "Live",
    video:
      "https://iframe.mediadelivery.net/embed/234682/3a9bbecd-283d-4523-b08b-c8c60cc07627",
    poster:
      "https://vz-ebdf7ee9-e45.b-cdn.net/3a9bbecd-283d-4523-b08b-c8c60cc07627/thumbnail.jpg",
  },
];
